import KinoPrivacyEffect from './KinoPrivacyEffect';
/**
 * Creates a new instance of KinoPrivacyEffect. This loads the Meet background model that is used to
 * extract person segmentation.
 *
 * @param {Object} virtualBackground - The virtual object that contains the background image source and
 * the isVirtualBackground flag that indicates if virtual image is activated.
 * @returns {Promise<KinoPrivacyEffect>}
 */
export async function createPrivacyEffect(virtualBackground) {
    if (!MediaStreamTrack.prototype.getSettings && !MediaStreamTrack.prototype.getConstraints) {
        throw new Error('KinoPrivacyEffect not supported!');
    }

    return new KinoPrivacyEffect(virtualBackground);
}